import { Box } from "@mui/material";
import styles from "./styles.module.css";
import { HeadingText, ParagraphText, UBButton } from "../../../Libraries";
import { useContext, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { VideoModal } from "../Modals";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const NonIdealNew = ({
  title,
  subtitle,
  button1Title,
  onButton1Click,
  iconPlacementBtn1,
  button2Title,
  onButton2Click,
  loading,
  disabledOne,
  disabledTwo,
  buttonOneId,
  buttonTwoId,
  prefixIconButtonTwo,
  prefixIconButtonOne,
  listButton2Title,
  listButtonTwoloading = false,
  onListButton2Click,
  listDisabledTwo = false,
  prefixIconListButtonTwo,
  listButtonTwoId,
  listButton2ClassName,
  isTransparentListButton2 = false,
  isTransparentButtonOne = false,
  video_url,
  video_footer,
  listButton3Title,
  listButtonThreeId,
  listButtonThreeloading,
  onListButton3Click,
  listDisabledThree,
  prefixIconListButtonThree,
  videoTitle,
  videoSubtitle,
  customClassName,
  mainIcon
}) => {
  const [I18n] = useContext(LanguageContext);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const handleWatchVideo = () => {
    triggerLogEvent(analytics, "watch_tutorial_video");
    setIsVideoModalOpen(true);
  };

  return (
    <Box className={`${styles.mainContainer} ${customClassName ? customClassName : ""}`}>
      <Box className={styles.innerContainer}>


        {mainIcon && <Box className={styles.mainIcon}>{mainIcon}</Box>}

        <HeadingText className={"fontSize24 fontWeight500 newFontColor"}>
          {title}
        </HeadingText>

        <ParagraphText
          className={`fontSize14 fontWeight400 newLightColor ${styles.subtitle}`}
        >
          {subtitle}
        </ParagraphText>

        <Box className={styles.buttonContainer}>
          {button1Title ? (
            <UBButton
              title={I18n[button1Title] || button1Title}
              loading={loading}
              spinnerColor={isTransparentButtonOne ? "mainColor" : "white"}
              id={buttonOneId}
              onClick={onButton1Click}
              disabled={disabledOne || loading}
              className={
                isTransparentButtonOne
                  ? styles.nonIdealTransparentButton
                  : styles.nonIdealPrimaryButton
              }
              iconRightSideComponent={iconPlacementBtn1 !== "left" ? prefixIconButtonOne : null}
              iconPlacement={iconPlacementBtn1 || "right"}
              iconComponent={iconPlacementBtn1 === "left" ? prefixIconButtonOne : null}
            />
          ) : null}

          {listButton2Title ? (
            <UBButton
              title={I18n[listButton2Title]}
              loading={listButtonTwoloading}
              spinnerColor="white"
              id={listButtonTwoId}
              onClick={onListButton2Click}
              disabled={listDisabledTwo || listButtonTwoloading}
              className={listButton2ClassName || (isTransparentListButton2 ? styles.nonIdealTransparentButton : styles.nonIdealPrimaryButton)}
              iconRightSideComponent={prefixIconListButtonTwo}
              iconPlacement="right"
            />
          ) : null}
          {listButton3Title ? (
            <UBButton
              title={I18n[listButton3Title]}
              loading={listButtonThreeloading}
              spinnerColor="white"
              id={listButtonThreeId}
              onClick={onListButton3Click}
              disabled={listDisabledThree || listButtonThreeloading}
              className={styles.nonIdealPrimaryButton}
              iconRightSideComponent={prefixIconListButtonThree}
              iconPlacement="right"
            />
          ) : null}
        </Box>

        {button2Title && (
          <UBButton
            title={I18n[button2Title]}
            loading={loading}
            spinnerColor="newFontColor"
            id={buttonTwoId}
            onClick={() =>
              onButton2Click ? onButton2Click() : handleWatchVideo()
            }
            disabled={disabledTwo || loading}
            iconComponent={prefixIconButtonTwo}
            className={`${styles.nonIdealSecondaryButton}`}
          />
        )}

        {isVideoModalOpen ? (
          <VideoModal
            open={isVideoModalOpen}
            onClose={() => setIsVideoModalOpen(false)}
            youtubeEmbedUrl={video_url}
            footer={video_footer}
            title={videoTitle}
            subtitle={videoSubtitle}
          />
        ) : null}
      </Box>
    </Box>
  );
};

export default NonIdealNew;
